import {ApplicationState} from "../../store";

export const getIsRedirectToSurveyEnabled = (state: ApplicationState) => state.clinicInformation.featureFlags.satisfactorySurveyEnabled;

export const getSurveyErrorCode = (state: ApplicationState) => state.survey.errorCode;


// WEBPACK FOOTER //
// ./src/store/Survey/selectors.ts